export default __webpack_public_path__ + "static/media/bz.23af0d75.svg";